"use client";

import { useEffect, useState } from "react";

/**
 * Fixed scroll-progress bar pinned to the top of the viewport. Width tracks
 * scrollTop / (scrollHeight - clientHeight). Passive scroll listener.
 */
export function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const el = document.documentElement;
      const max = el.scrollHeight - el.clientHeight;
      const pct = max > 0 ? (el.scrollTop || document.body.scrollTop) / max : 0;
      setProgress(Math.min(1, Math.max(0, pct)));
    };
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <div
      className="md-blog-progress"
      style={{ width: `${progress * 100}%` }}
      aria-hidden
    />
  );
}
